import * as React from 'react';

import { Link } from 'react-router-dom';

import Base from './Base';

/* @jsxImportSource @emotion/react */  import { css, jsx } from '@emotion/react'; /* eslint-disable-line */

const componentCss = css`


`;

export default React.forwardRef(({ selectedNav, index }, ref) => {

	return <div css={componentCss}>
		<Base ref={ref} index={index} selectedNav={selectedNav}>
			<div className="megamenu">
				<div className="megamenu-columns">
					<div className="primary-columns">
						<h2>Zones / Address</h2>
						<div className="columns-2">
							<div className="primary-column">
								<h3>Manage Depots</h3>
								<Link to="/z/depots/all" >
									<div className="megamenu-link">
										<div className="logo-wrapper">
											<div className="megamenu-icon">
												<i className="fa-solid fa-warehouse" />
											</div>
										</div>
										<div>
											<h4>List Depots</h4>
											<p className="link-subtext">List all Depots</p>
										</div>
									</div>
								</Link>
							</div>
							<div className="primary-column">
								<h3>Manage Addresses</h3>
								<Link to="/z/address/all" >
									<div className="megamenu-link">
										<div className="logo-wrapper">
											<div className="megamenu-icon">
												<i className="fa-solid fa-cat" />
											</div>
										</div>
										<div>
											<h4>List Addresses</h4>
											<p className="link-subtext">List all Addresses</p>
										</div>
									</div>
								</Link>
							</div>
						</div>
					</div>
					<div className="secondary-columns">
						<ul>

						</ul>
					</div>
				</div>
			</div>
		</Base>
	</div>

});
